import * as React from 'react'

import { Hero } from './sections/Hero'
import { Profiles } from './sections/Profiles'
import { Contact } from './sections/Contact'

/**
 * Contact page ("Contacter Ulule") main content.
 *
 * Both server-rendered (prerender) and hydrated on the client, so it must stay pure: no
 * `window`/`document`/`localStorage`/`matchMedia` reads during render and no per-request values.
 * Interactive bits (the profile accordion, the form's Zendesk hand-off) put their browser work in
 * event handlers / effects and render a deterministic initial state so hydration matches the SSR HTML.
 * The site header/footer are NOT part of this tree — they are mounted separately (see entry-client).
 */
export function App(): React.ReactElement {
  return (
    <main>
      <Hero />
      <Profiles />
      <Contact />
    </main>
  )
}
